package gr.tech.GRAttestation.sections.tables

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.models.activity.ActivityDTO
import gr.tech.GRAttestation.navigation.AdminSitePage
import gr.tech.GRAttestation.sections.admin.AdminTableContainer
import gr.tech.GRAttestation.styles.grstyles.BPlaceholder
import gr.tech.GRAttestation.styles.grstyles.DefaultTableHeaderStyle
import gr.tech.GRAttestation.styles.grstyles.Theme
import gr.tech.GRAttestation.util.TimeUtils.formatDateOnly
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun AdminActivitySummaryTable(
    activity: List<ActivityDTO>,
) {
    AdminTableContainer(
        modifier = Modifier.fillMaxHeight()
    ) {
        Table(
            attrs = Modifier
                .classNames("table")
                .fillMaxWidth()
                .toAttrs()
        ) {
            Thead(
                attrs = Modifier
                    .styleModifier {
                        property("table-layout", "fixed")
                    }
                    .toAttrs()
            ) {
                Tr {
                    listOf(
                        "Activity",
                        "Admin",
                        "Created At",
                        "Store?",
                        "Form?",
                        "SKU?",
                    ).forEach { header ->
                        Th(
                            attrs = DefaultTableHeaderStyle.toModifier()
                                .classNames("col").toAttrs()
                        ) { Text(header) }
                    }
                }
            }
            Tbody {
                if (activity.isNotEmpty()) {
                    activity.forEach { item ->
                        AdminActivitySummaryRow(item)
                    }
                } else {
                    repeat(2) {
                        AdminActivitySummaryRow(null)
                    }
                }
            }
        }
    }
}


@Composable
fun AdminActivitySummaryRow(
    adminActivity: ActivityDTO?,
) {
    Tr(Modifier.height(57.px).toAttrs()) {
        adminActivity?.let { activity ->
            Td(
                attrs = Modifier.toAttrs()
            ) {
                Text(activity.activity)
            }
            Td { Text(activity.userIdentity) }
            Td {
                Span { Text(formatDateOnly(activity.createdAt)) }
                TableDateTimeTooltip(activity.createdAt)
            }
            Td {
                activity.storeId?.let { id ->
                    Link(
                        path = AdminSitePage.Stores.passStoreId(id.toString()),
                        variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
                        modifier = Modifier.textDecorationLine(TextDecorationLine.Underline).color(Theme.DarkGreen.rgb).cursor(Cursor.Pointer)
                    ) {
                        Text(id.toString())
                    }
                } ?: run {
                    Text("-")
                }
            }
            Td { Text((activity.formId ?: "-").toString()) }
            Td { Text((activity.skuId ?: "-").toString()) }

        } ?: run {
            Td { BPlaceholder(Modifier.width(200.px)) }
            Td { BPlaceholder(Modifier.width(100.px)) }
            Td { BPlaceholder() }
            Td { BPlaceholder() }
            Td { BPlaceholder() }
            Td { BPlaceholder() }
        }
    }
}